module.exports = __webpack_public_path__ + "static/media/shopping-white.ac656f60.svg";